document.addEventListener("DOMContentLoaded", function () {
  function updateEofySavings() {
    const priceEl = document.querySelector('.price__current');
    const compareEl = document.querySelector('.price__was');

    if (!priceEl || !compareEl) return;

    const price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    const compare = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));

    // EOFY savings message
    let savingsBox = document.querySelector('.eofy-savings-dynamic');
    if (!savingsBox) {
      savingsBox = document.createElement('p');
      savingsBox.className = 'eofy-savings-dynamic';
      savingsBox.style.color = '#D32F2F'; // deep red
      savingsBox.style.fontSize = '1.2rem';
      savingsBox.style.fontWeight = '600';
      savingsBox.style.marginTop = '0.4rem';
      savingsBox.style.marginBottom = '0.2rem';
      savingsBox.style.background = 'transparent';
      priceEl.closest('.price').appendChild(savingsBox);
    }

    if (compare > price) {
      const savings = (compare - price).toFixed(2);
      const percent = Math.round((savings / compare) * 100);
      savingsBox.textContent = `Save $${savings} – That’s ${percent}% Off RRP`;
      savingsBox.style.display = 'block';
    } else {
      savingsBox.textContent = '';
      savingsBox.style.display = 'none';
    }

    // Free shipping message
    let shippingBox = document.querySelector('.free-shipping-dynamic');
    if (!shippingBox) {
      shippingBox = document.createElement('p');
      shippingBox.className = 'free-shipping-dynamic';
      shippingBox.style.color = '#2E7D32'; // green
      shippingBox.style.fontSize = '1.05rem';
      shippingBox.style.fontWeight = '500';
      shippingBox.style.marginTop = '0.3rem';
      priceEl.closest('.price').appendChild(shippingBox);
    }
    shippingBox.textContent = 'Free Metro Shipping on Orders Over $450 (Excludes WA & NT) - $9.99 Flat Rate Under $450 (Excludes WA & NT)';
  }

  updateEofySavings();

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id') {
      setTimeout(updateEofySavings, 100);
    }
  });
});
